import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// Obtener todas las tasas de cambio
export const getAllExchangeRates = async () => {
  const token = localStorage.getItem("token"); // Asegúrate de que el token esté presente
  if (!token) {
    console.error("Token no encontrado");
    throw new Error("Token no encontrado");
  }

  try {
    const response = await axios.get(`${API_URL}/api/exchange-rates`, {
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en los encabezados
      },
    });

    return response.data; // Devuelve la lista de tasas
  } catch (error) {
    console.error("Error al obtener las tasas de cambio:", error);
    throw error;
  }
};

// Obtener tasa de cambio entre dos monedas
// Obtener la última tasa de cambio entre dos monedas
export const getExchangeRate = async (fromCurrency, toCurrency) => {
  const token = localStorage.getItem("token"); // Asegúrate de que el token esté presente
  if (!token) {
    console.error("Token no encontrado");
    throw new Error("Token no encontrado");
  }

  try {
    const response = await axios.get(`${API_URL}/api/exchange-rate`, {
      params: { fromCurrency, toCurrency },
      headers: {
        Authorization: `Bearer ${token}`, // Agrega el token en los encabezados
      },
    });

    if (!response.data.rate) {
      console.error(
        `No exchange rate returned for ${fromCurrency} to ${toCurrency}`
      );
      return null;
    }

    return response.data.rate;
  } catch (error) {
    console.error("Error al obtener la tasa de cambio:", error);
    throw error;
  }
};

// Agregar nueva tasa de cambio
export const addExchangeRate = async (fromCurrency, toCurrency, rate, date) => {
  const token = localStorage.getItem("token"); // Asegúrate de que el token esté presente
  if (!token) {
    console.error("Token no encontrado");
    throw new Error("Token no encontrado");
  }

  try {
    const response = await axios.post(
      `${API_URL}/api/exchange-rate`,
      {
        fromCurrency,
        toCurrency,
        rate,
        date,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Agrega el token en los encabezados
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al agregar la tasa de cambio:", error);
    throw error;
  }
};

// Eliminar una tasa de cambio
export const deleteExchangeRate = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) {
    console.error("Token no encontrado");
    throw new Error("Token no encontrado");
  }

  try {
    await axios.delete(`${API_URL}/api/exchange-rate/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Error al eliminar la tasa de cambio:", error);
    throw error;
  }
};
// Obtener todas las monedas
export const getCurrencies = async () => {
  const token = localStorage.getItem("token"); // Asegúrate de que el token esté presente
  if (!token) {
    console.error("Token no encontrado");
    throw new Error("Token no encontrado");
  }

  try {
    const response = await axios.get(`${API_URL}/api/currencies`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Devuelve la lista de monedas
  } catch (error) {
    console.error("Error al obtener las monedas:", error);
    throw error;
  }
};
